<template>
  <v-card flat>
    <v-card-title>
      Sensor Data - Beringar Staff Display
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="fa-search"
        label="Find a sensor"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table :headers="headers" :items="tableItems" :search="search">
      <template v-if="link" v-slot: item.name="{ item }">
        <router-link :to="item.link">{{ item.name }}</router-link>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>

import { prettyDateFromUtcTimestampYYYYMMDDHHMM } from '@/lib/timeutil'
import { roundOrNull } from '@/lib/formatUtil'

export default {
  name: 'sensortable',
  props: {
    sensorData: Array, link: Boolean
  },
  data: () => {
    return {
      headers: [
        { text: 'Sensor Name', value: 'name', filterable: true },
        { text: 'Lora Address', value: 'loraAddress', filterable: true },
        { text: 'Map Marker Label', value: 'mapMarkerLabel', filterable: true },
        { text: 'Occupancy', value: 'occupancy' },
        { text: 'Temp', value: 'temperature' },
        { text: 'Noise', value: 'noise' },
        { text: 'CO2', value: 'co2' },
        { text: 'CO2 HQ', value: 'co2hq' },
        { text: 'CO2 BME', value: 'co2bme' },
        { text: 'Voc', value: 'Voc' },
        { text: 'Raw Gas BME', value: 'rawgasbme' },
        { text: 'AQ 1', value: 'aqi1' },
        { text: 'AQ 2', value: 'aqi2' },
        { text: 'Humid', value: 'humid' },
        { text: 'Pressure', value: 'pressure' },
        { text: 'Lux', value: 'lux' },
        { text: 'Bearing', value: 'bearing' },
        { text: 'Int Humid', value: 'internalhumid' },
        { text: 'Int Temp', value: 'internaltemperature' },
        { text: 'Time YYYY-MM-DD', value: 'datetime' },
        // { text: 'Timestamp', value: 'timestamp' },
        // { text: 'Sensor Loc UUID', value: 'sensorlocationid' },
        { text: 'Device UUID', value: 'deviceid' }
      ],
      search: ''
    }
  },
  computed: {
    tableItems: function () {
      if (!this.sensorData) {
        return []
      }
      return this.sensorData.map(row => {
        return {
          name: row.name,
          loraAddress: row.loraAddress,
          mapMarkerLabel: row.mapMarkerLabel,
          roomName: row.roomName,
          link: row.link,
          occupancy: row.sensor.occupancy,
          co2: roundOrNull(row.sensor.co2),
          noise: roundOrNull(row.sensor.noise),
          temperature: roundOrNull(row.sensor.temperature),
          co2hq: roundOrNull(row.sensor.co2hq),
          co2bme: roundOrNull(row.sensor.co2bme),
          voc: roundOrNull(row.sensor.voc),
          rawgasbme: roundOrNull(row.sensor.rawgasbme),
          aqi1: roundOrNull(row.sensor.aqi1),
          aqi2: roundOrNull(row.sensor.aqi2),
          humid: roundOrNull(row.sensor.humid),
          pressure: roundOrNull(row.sensor.pressure),
          lux: roundOrNull(row.sensor.lux),
          bearing: roundOrNull(row.sensor.bearing),
          internalhumid: roundOrNull(row.sensor.internalhumid),
          internaltemperature: roundOrNull(row.sensor.internaltemperature),
          datetime: prettyDateFromUtcTimestampYYYYMMDDHHMM(row.sensor.time_epoch_milli),
          timestamp: row.sensor.time_epoch_milli,
          sensorlocationid: row.sensor.sensorlocationid,
          deviceid: row.sensor.deviceid
        }
      })
    }
  }
}
</script>
